import { useEffect } from "react";
import Lenis from "lenis";
import { motion } from "framer-motion";
import "@/App.css";
import { LanguageProvider, useLang } from "@/LanguageContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Disciplines from "@/components/Disciplines";
import Why from "@/components/Why";
import Testimonials from "@/components/Testimonials";
import Books from "@/components/Books";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Grain = () => (
  <div
    aria-hidden
    className="pointer-events-none fixed inset-0 z-[65] opacity-[0.05] mix-blend-multiply"
    style={{
      backgroundImage:
        'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.85\' numOctaves=\'2\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")',
    }}
  />
);

const Page = () => {
  const { t, lang } = useLang();
  return (
    <div className="bg-linen text-ink">
      <Header />
      <motion.main
        key={lang}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.45, ease: "easeOut" }}
      >
      <Hero />
      <Marquee items={t.marquee} />
      <About />
      <Disciplines />
      <Marquee items={t.marquee} reverse dark />
      <Why />
      <Testimonials />
      <Books />
      <Contact />
      <Footer />
      </motion.main>
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <Grain />
      <Page />
    </LanguageProvider>
  );
}

export default App;
